module.exports = __webpack_public_path__ + "static/song-of-broken-pines-a682654a83cf2c96fb897c20e007fa45.png";